// ============================================================
// SOPHIA HOME — Scroll Reveal par section
// assets/sophia-animations.js
// IntersectionObserver natif, aucune librairie externe.
// ============================================================

(function () {
  'use strict';

  // Arrêt immédiat si l'utilisateur a désactivé les animations dans son OS.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SECTION_SELECTOR = '.shopify-section';
  var INIT_CLASS = 'sh-reveal';
  var VISIBLE_CLASS = 'sh-reveal--visible';

  function initScrollReveal() {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll(SECTION_SELECTOR)
    );
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px', threshold: 0.08 }
    );

    sections.forEach(function (section, index) {
      // La première section (bannière hero) est déjà visible : on la marque
      // directement visible sans la masquer ni l'observer.
      if (index === 0) {
        section.classList.add(VISIBLE_CLASS);
        return;
      }
      section.classList.add(INIT_CLASS);
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Dans l'éditeur Shopify, les sections peuvent être rechargées dynamiquement.
  // On les révèle immédiatement pour ne pas bloquer la prévisualisation.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      var hidden = document.querySelectorAll(
        '.' + INIT_CLASS + ':not(.' + VISIBLE_CLASS + ')'
      );
      Array.prototype.slice.call(hidden).forEach(function (el) {
        el.classList.add(VISIBLE_CLASS);
      });
    });
  }
})();
